<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <div class="table">
          <el-table
            ref="multipleTable"
            border
            tooltip-effect="dark"
            :data="tableData"
            min-height="350px"
            :header-cell-style="{background:'#f5f7fa',color:'#606266'}"
            style="width: 100%">
            <el-table-column
              label="课程名称"
             >
              <template slot-scope="scope">{{scope.row.sequence}}：{{ scope.row.module_name }}</template>
            </el-table-column>
            <el-table-column
              label="班级名称"
              >
              <template> {{className}}</template> 
            </el-table-column>
            <el-table-column
              label="讲师"
             >
              <template slot-scope="scope">
                <span v-for="(item,index) in scope.row.teacher " :key="index">{{item}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="上课日期"
             >
              <template slot-scope="scope">{{ scope.row.date }}</template>
            </el-table-column>
            <el-table-column
              label="上课时间"
             >
              <template slot-scope="scope">{{ scope.row.begin_time }} <span v-if="scope.row.end_time">-</span> {{ scope.row.end_time }}</template>
            </el-table-column>
            <el-table-column
              label="管理码"
              width="80"
             >
              <template slot-scope="scope">{{ scope.row.admin_code }}</template>
            </el-table-column>
            <el-table-column
              label="老师码"
              width="80"
             >
              <template slot-scope="scope">{{ scope.row.teacher_code }}</template>
            </el-table-column>
            <el-table-column
              label="学员码"
              width="80"
             >
              <template slot-scope="scope">{{ scope.row.student_code }}</template>
            </el-table-column>
            <el-table-column
              width='135'
              label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.gc_id > 0 && scope.row.has_room != 0"
                  size="mini"
                  type="primary" plain
                  @click="handleEdit(scope.$index, scope.row)" >编辑</el-button>
                <el-button
                  v-if="scope.row.play_back_url"
                  size="mini"
                  type="primary" plain
                  @click="playback(scope.$index, scope.row)" >回放链接</el-button>
                <el-button
                  v-if="scope.row.web_share_url"
                  size="mini"
                  type="primary" plain
                  @click="live(scope.$index, scope.row)" >直播链接</el-button>
                <el-button
                  v-if="scope.row.has_room === 0"
                  size="mini"
                  type="primary"
                  @click="handleCreate(scope.$index, scope.row)" >创建直播间</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { total,page, page_size} from '../../../config'
// @ is an alias to /src
export default {
  name: 'Class',
  components: {
  },
  data(){
    return {
      tableData: [],
      centerDialog: false,
      total,
      page,
      page_size,
      deleteList:[],
      periodArr:[],
      className:''
    }
  },
  created(){
    this.id = this.$route.params && this.$route.params.id
    this.className = this.$route.query.className
  },
  mounted(){
    let params = {
      group_id:this.id
    }
    this.getinfor(params)
  },
  methods:{
    getinfor(params){
      this.$api.user.classTimetable(params)
        .then(res=>{
            if(res.code === 0){
              this.tableData = res.result
              this.total = res.result.total
            }else if(res.code === 1010){
              this.tableData = []
              this.total = 0
            }
        }) 
    },
    playback(index,row){
      let url = row.play_back_url;
      let oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      });
      oInput.remove()
    },
    live(index,row){
      let url = row.web_url;
      let oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      });
      oInput.remove()
    },
    handleEdit(index,row){
      this.$router.push({
        path:'/class/relationEdit/' + row.gc_id,
        query:{
          group:this.id,
          item:row.item_id,
          template:row.template_id,
          name:this.className,
        }
      })
    },
    handleCreate(index,row){
      this.$router.push({
        path:'/class/relationClass/' + row.item_id,
        query:{
          group:this.id,
          template:row.template_id,
          name:this.className,
          sequence:row.sequence,
          courseName:row.module_name,
        }
      })
    },
  },
    
}
</script>
<style lang="scss" scoped>
  @import '../../../assets/scss/content.scss';
  // @import '../../assets/scss/period.scss';
</style>